/** @jsxImportSource @emotion/react */
import {
  useAccountPermissions,
  useTenantPermissions,
  UseAccountPermissionsType
} from './fetchHooks'
import { AccessType } from './types'
import { GenericFetchHookParamsType } from '@signal/core/contextFetch'
import createContextFetchLoader from '@signal/core/contextFetch/Loader'
import { AccountPermissionsContext, TenantPermissionsContext } from './Context'

export const AccountPermissionsFetcher = createContextFetchLoader<
  Array<AccessType>,
  UseAccountPermissionsType
>({
  fetchHook: useAccountPermissions,
  FetchContext: AccountPermissionsContext
})

export const TenantPermissionsFetcher = createContextFetchLoader<
  Array<AccessType>,
  GenericFetchHookParamsType
>({
  fetchHook: useTenantPermissions,
  FetchContext: TenantPermissionsContext
})

export default AccountPermissionsFetcher
